/**
 * DOMPurify-backed HTML rendering for learner content.
 */
import React from "react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";

import { PT, asBool, asString } from "utils/safeData";

const COURSE_CONFIG = {
  ADD_TAGS: ["iframe", "video", "audio", "source"],
  ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "target", "rel", "controls", "autoplay", "sandbox", "referrerpolicy", "width", "height", "src"],
};

/**
 * Sanitizes HTML, optionally allowing course media tags such as iframe and video.
 *
 * @param {string} html Raw HTML.
 * @param {{ course?: boolean }} [options]
 * @returns {string}
 */
export function sanitizeHtml(html, { course = false } = {}) {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), course ? COURSE_CONFIG : undefined);
}

/**
 * Renders sanitized HTML into a chosen tag.
 *
 * @param {{ html?: string, className?: string, as?: string, course?: boolean }} props
 */
export default function SafeHtml({ html, className, as: Tag = "div", course = false, ...rest }) {
  return <Tag className={asString(className)} dangerouslySetInnerHTML={{ __html: sanitizeHtml(html, { course: asBool(course) }) }} {...rest} />;
}

SafeHtml.propTypes = {
  html: PT.text,
  className: PropTypes.string,
  as: PropTypes.elementType,
  course: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
};
